(function() {
  'use strict';

  window.tuckRebuySmartCartEnabled = true;

  var SHIPPING_THRESHOLD = 13000;
  var RECOMMENDATIONS_WIDGET_ID = '181237';
  var RETRY_LIMIT = 120;
  var JUDGE_ME_GROUPS = [
    { name: 'bamboo', productId: '7905781514329', pattern: /\bbamboo\b/i },
    { name: 'boys-boardshorts', productId: '7913183772761', pattern: /board\s*short|boardie/i },
    { name: 'girls-swim-baby-romper-swim', productId: '7913183674457', pattern: /\bswim|swimsuit|bikini|rash\s*guard|\bromper\b/i },
    { name: 'sweatsuits', productId: '7651273736281', pattern: /\bsweatsuit/i },
    { name: 'jackets', productId: '8101624447065', pattern: /\bjacket\b/i },
    { name: 'sweatshirts-hoodies', productId: '7820005212249', pattern: /hoodie|sweatshirt|crewneck|sweater/i },
    { name: 'hats', productId: '8219967455321', pattern: /\bhat\b|\bcaps?\b|snapback|beanie/i },
    { name: 'backpacks-lunchpale', productId: '7977344598105', pattern: /backpack|lunch\s*(?:box|bag|pail|pale)/i },
    { name: 'tshirts', productId: '7703951245401', pattern: /t-?shirt|\btee\b/i },
    { name: 'shorts', productId: '8152711987289', pattern: /\bshorts?\b/i }
  ];
  var retryCount = 0;
  var judgeMeLoading = false;
  var judgeMeCartSignature = '';

  function configureRecommendations(event) {
    var widget = event && event.detail && event.detail.widget;

    if (!widget || String(widget.id) !== RECOMMENDATIONS_WIDGET_ID || !widget.data) {
      return;
    }

    [widget.data.settings, widget.data.config].forEach(function(settings) {
      var layout = settings && settings.layout;

      if (!layout) {
        return;
      }

      if (layout.large) {
        layout.large.carousel = true;
        layout.large.columns = 2;
        layout.large.show_paginations = true;
      }

      if (layout.medium) {
        layout.medium.carousel = true;
        layout.medium.columns = 2;
        layout.medium.show_paginations = true;
        layout.medium.style = 'grid';
      }

      if (layout.small) {
        layout.small.carousel = true;
        layout.small.columns = 2;
        layout.small.show_paginations = true;
      }
    });
  }

  function getShopifyCart(event) {
    var eventCart = event && event.detail && event.detail.cart;

    if (eventCart && eventCart.cart) {
      return eventCart.cart;
    }

    if (eventCart && Array.isArray(eventCart.items)) {
      return eventCart;
    }

    if (window.Rebuy && Rebuy.Cart && Rebuy.Cart.cart) {
      return Rebuy.Cart.cart;
    }

    return null;
  }

  function formatMoney(cents, currency) {
    var locale = (window.Shopify && Shopify.locale) || document.documentElement.lang || 'en-US';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency || 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (error) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function goalMarkup(type, icon, label) {
    return '<div class="tuck-rebuy-goal" data-tuck-rebuy-goal="' + type + '">' +
      '<span class="tuck-rebuy-goal__icon" aria-hidden="true">' + icon + '</span>' +
      '<div class="tuck-rebuy-goal__content">' +
        '<div class="tuck-rebuy-goal__message" data-tuck-rebuy-goal-message></div>' +
        '<div class="tuck-rebuy-goal__track" role="progressbar" aria-label="' + label + '" aria-valuemin="0" data-tuck-rebuy-goal-progress>' +
          '<span class="tuck-rebuy-goal__fill" data-tuck-rebuy-goal-fill></span>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function ensureGoals() {
    var body = document.querySelector('#rebuy-cart [data-rebuy-cart-anchor="body"]');
    if (!body) {
      return null;
    }

    if (body.parentElement) {
      body.parentElement.classList.add('tuck-rebuy-cart-body-shell');
    }

    var existing = document.querySelector('[data-tuck-rebuy-goals]');
    if (existing) {
      return existing;
    }

    var truckIcon = '<svg viewBox="0 0 24 24" focusable="false"><path d="M3 6.5h10.5v10H3zM13.5 10h3.8l3.2 3.4v3.1h-7z"/><circle cx="7" cy="18" r="2"/><circle cx="17.5" cy="18" r="2"/></svg>';
    var goals = document.createElement('div');
    goals.className = 'tuck-rebuy-goals';
    goals.setAttribute('data-tuck-rebuy-goals', '');
    goals.innerHTML = goalMarkup('shipping', truckIcon, 'Progress toward free shipping');

    body.insertBefore(goals, body.firstChild);

    return goals;
  }

  function updateShippingGoal(panel, total, threshold, currency) {
    var goal = panel.querySelector('[data-tuck-rebuy-goal="shipping"]');
    if (!goal) {
      return;
    }

    var remaining = Math.max(threshold - total, 0);
    var applied = Math.min(total, threshold);
    var progress = threshold ? Math.min((total / threshold) * 100, 100) : 0;
    var message = remaining > 0
      ? 'You\u2019re ' + formatMoney(remaining, currency) + ' Away From Free Shipping'
      : 'You Unlocked Free Shipping!';

    goal.querySelector('[data-tuck-rebuy-goal-message]').textContent = message;
    goal.querySelector('[data-tuck-rebuy-goal-fill]').style.width = progress + '%';

    var progressbar = goal.querySelector('[data-tuck-rebuy-goal-progress]');
    progressbar.setAttribute('aria-valuemax', threshold);
    progressbar.setAttribute('aria-valuenow', applied);
    progressbar.setAttribute('aria-valuetext', message);
  }

  function updateTitle(cart) {
    var title = document.getElementById('rebuy-cart-title');
    if (!title) {
      return;
    }

    title.textContent = cart.item_count > 0
      ? 'Your Cart (' + cart.item_count + ')'
      : 'Your Cart';
  }

  function buildJudgeMeHost() {
    var existing = document.querySelector('[data-tuck-judge-me-host]');
    if (existing) {
      return existing;
    }

    var footer = document.querySelector('#rebuy-cart [data-rebuy-cart-anchor="footer"]');
    if (!footer) {
      return null;
    }

    var host = document.createElement('div');
    host.className = 'tuck-judge-me-host';
    host.setAttribute('data-tuck-judge-me-host', '');
    host.innerHTML = '<aside class="tuck-rebuy-review" data-tuck-rebuy-review hidden aria-label="Verified customer review">' +
        '<span class="tuck-rebuy-review__mark" aria-hidden="true">J</span>' +
        '<div class="tuck-rebuy-review__content">' +
          '<div class="tuck-rebuy-review__meta">' +
            '<span class="tuck-rebuy-review__stars" data-tuck-review-stars aria-hidden="true"></span>' +
            '<span data-tuck-review-rating></span>' +
            '<span class="tuck-rebuy-review__verified">Verified</span>' +
          '</div>' +
          '<p class="tuck-rebuy-review__quote" data-tuck-review-quote></p>' +
          '<p class="tuck-rebuy-review__product" data-tuck-review-product></p>' +
        '</div>' +
      '</aside>';

    footer.appendChild(host);
    return host;
  }

  function populateJudgeMeReview(host, score, quote, product) {
    var card = host.querySelector('[data-tuck-rebuy-review]');
    if (!card) {
      return false;
    }

    var fullStars = Math.max(1, Math.min(5, Math.round(score)));
    card.querySelector('[data-tuck-review-stars]').textContent = '★★★★★'.slice(0, fullStars);
    card.querySelector('[data-tuck-review-rating]').textContent = score.toFixed(1);
    card.querySelector('[data-tuck-review-quote]').textContent = '“' + quote.trim() + '”';
    card.querySelector('[data-tuck-review-product]').textContent = 'Review for ' + product.trim();
    card.hidden = false;
    return true;
  }

  function itemHandle(item) {
    var itemUrl = String(item.url || '');
    var urlMatch = itemUrl.match(/\/products\/([^?/#]+)/);
    return item.handle || item.product_handle || (urlMatch && urlMatch[1]) || '';
  }

  function productReviewText(item, product) {
    var itemProduct = item.product || {};
    var values = [
      item.product_title,
      item.title,
      item.product_type,
      itemProduct.title,
      itemProduct.description,
      itemProduct.product_type
    ];

    if (product) {
      values.push(product.title, product.description, product.product_type, product.type, product.tags);
    }

    return values.filter(Boolean).join(' ');
  }

  function classifyJudgeMeGroup(text) {
    for (var index = 0; index < JUDGE_ME_GROUPS.length; index += 1) {
      if (JUDGE_ME_GROUPS[index].pattern.test(text)) {
        return JUDGE_ME_GROUPS[index];
      }
    }

    return null;
  }

  function productDetails(item) {
    var handle = itemHandle(item);
    if (!handle) {
      return Promise.resolve(null);
    }

    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' }).then(function(response) {
      return response.ok ? response.json() : null;
    }).catch(function() {
      return null;
    });
  }

  function relevantJudgeMeGroup(cart) {
    var items = cart.items || [];
    return Promise.all(items.map(function(item) {
      return productDetails(item).then(function(product) {
        return classifyJudgeMeGroup(productReviewText(item, product));
      });
    })).then(function(groups) {
      return groups.find(Boolean) || null;
    });
  }

  function fetchJudgeMeGroupReview(group) {
    var params = [
      'product_ids%5B%5D=' + encodeURIComponent(group.productId),
      'per_product_limit=5',
      'primary_language=en',
      'translation_locale=en',
      'shop_domain=f413d6-35.myshopify.com',
      'platform=shopify'
    ];
    var url = 'https://cdn.judge.me/reviews/reviews_for_cart?' + params.join('&');

    return fetch(url, { credentials: 'omit', mode: 'cors' }).then(function(response) {
      if (!response.ok) {
        throw new Error('Judge.me review request failed');
      }
      return response.json();
    }).then(function(data) {
      var products = data.products || [];
      var reviews = products.reduce(function(allReviews, product) {
        return allReviews.concat(product.reviews || []);
      }, []);

      return reviews.find(function(review) {
        return review.verified_buyer === true && Number(review.rating) === 5 &&
          Boolean(review.title || review.body) && Boolean(review.product_title);
      }) || null;
    });
  }

  function judgeMeSignature(cart) {
    return (cart.items || []).map(function(item) {
      return String(item.product_id || (item.product && item.product.id) || item.handle || '');
    }).filter(Boolean).sort().join(',');
  }

  function resetJudgeMeReview() {
    var host = document.querySelector('[data-tuck-judge-me-host]');
    if (host) {
      host.remove();
    }

    judgeMeLoading = false;
  }

  function ensureJudgeMeReview(cart) {
    var signature = judgeMeSignature(cart);
    var host = document.querySelector('[data-tuck-judge-me-host]');

    if (!cart.item_count) {
      if (judgeMeCartSignature || host) {
        judgeMeCartSignature = '';
        resetJudgeMeReview();
      }
      return;
    }

    if (signature !== judgeMeCartSignature) {
      judgeMeCartSignature = signature;
      resetJudgeMeReview();
      host = null;
    }

    host = host || buildJudgeMeHost();
    if (!host) {
      return;
    }

    if (judgeMeLoading || host.dataset.tuckReviewLoaded === signature) {
      return;
    }

    host.hidden = false;
    host.dataset.tuckReviewLoaded = signature;
    judgeMeLoading = true;
    relevantJudgeMeGroup(cart).then(function(group) {
      if (!group || signature !== judgeMeCartSignature || !host.isConnected) {
        return null;
      }

      host.dataset.tuckReviewGroup = group.name;
      return fetchJudgeMeGroupReview(group);
    }).then(function(review) {
      if (!review || signature !== judgeMeCartSignature || !host.isConnected) {
        return;
      }

      populateJudgeMeReview(host, Number(review.rating), review.title || review.body, review.product_title);
    }).catch(function() {
      var card = host.querySelector('[data-tuck-rebuy-review]');
      if (card) {
        card.hidden = true;
      }
    }).finally(function() {
      if (signature === judgeMeCartSignature) {
        judgeMeLoading = false;
      }
    });
  }

  function updateEmptyState(cart) {
    if (cart.item_count > 0) {
      return;
    }

    var emptyCart = document.querySelector('#rebuy-cart .rebuy-cart__flyout-empty-cart');
    if (!emptyCart || emptyCart.querySelector('[data-tuck-rebuy-empty]')) {
      return;
    }

    var emptyState = document.createElement('div');
    emptyState.className = 'tuck-rebuy-empty';
    emptyState.setAttribute('data-tuck-rebuy-empty', '');

    var title = document.createElement('h3');
    title.className = 'tuck-rebuy-empty__title';
    title.textContent = 'Your cart is empty';

    var message = document.createElement('p');
    message.className = 'tuck-rebuy-empty__message';
    message.textContent = 'Find a new coastal favorite for the family.';

    var button = document.createElement('a');
    button.className = 'tuck-rebuy-empty__button';
    button.href = '/collections/all';
    button.textContent = 'Shop now';

    emptyState.appendChild(title);
    emptyState.appendChild(message);
    emptyState.appendChild(button);
    emptyCart.replaceChildren(emptyState);
  }

  function update(cart) {
    var goals = ensureGoals();
    if (!goals || !cart) {
      return;
    }

    var currency = cart.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var shippingTotal = typeof cart.items_subtotal_price === 'number'
      ? cart.items_subtotal_price
      : cart.total_price || 0;

    goals.hidden = !cart.item_count;
    updateShippingGoal(goals, shippingTotal, SHIPPING_THRESHOLD, currency);
    updateTitle(cart);
    ensureJudgeMeReview(cart);
    updateEmptyState(cart);
  }

  function updateAfterRender(event) {
    var cart = getShopifyCart(event);

    window.requestAnimationFrame(function() {
      window.setTimeout(function() {
        update(cart || getShopifyCart());
      }, 0);
    });
  }

  function prepareSmartCart(event) {
    var smartcart = event && event.detail && event.detail.smartcart;
    var cartLinks = document.querySelectorAll('.js-drawer-open-cart');

    cartLinks.forEach(function(link) {
      link.setAttribute('aria-controls', 'rebuy-cart');
      link.setAttribute('aria-haspopup', 'dialog');
    });

    if (smartcart && smartcart.settings && Array.isArray(smartcart.settings.components)) {
      smartcart.settings.components.forEach(function(component) {
        if (component.type === 'title_bar' && component.settings) {
          component.settings.title = 'Your Cart';
        }

        if (component.type === 'checkout' && component.settings && component.settings.language) {
          component.settings.language.checkout_label = 'Checkout';
        }
      });
    }

    updateAfterRender(event);
  }

  function initializeWhenReady() {
    if (window.Rebuy && Rebuy.SmartCart && Rebuy.SmartCart.status === 'ready') {
      prepareSmartCart({ detail: { smartcart: Rebuy.SmartCart } });
      return;
    }

    retryCount += 1;
    if (retryCount < RETRY_LIMIT) {
      window.setTimeout(initializeWhenReady, 250);
    } else {
      window.tuckRebuySmartCartEnabled = false;

      if (window.theme && theme.CartDrawer && !document.body.classList.contains('template-cart')) {
        new theme.CartDrawer();
      }
    }
  }

  document.addEventListener('rebuy:smartcart.ready', prepareSmartCart);
  document.addEventListener('rebuy:cart.ready', updateAfterRender);
  document.addEventListener('rebuy:cart.change', updateAfterRender);
  document.addEventListener('rebuy.init', configureRecommendations);
  document.addEventListener('rebuy.beforeReady', configureRecommendations);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeWhenReady, { once: true });
  } else {
    initializeWhenReady();
  }
})();
